var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list_name"},[_c('img',{attrs:{"src":_vm.titleImg,"alt":""}}),_c('span',{staticClass:"font16 colo0 font_weight400 line_height_22"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }